import { Button, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ConnectionItem } from './ConnectionItem';
import { OutgoingConnection } from '../model/UserConnection';
import { useConnectionDispatch } from './ConnectionDispatchProvider';
import {
  useCancelConnectionRequest,
  useRequestConnect,
} from '../hook/useConnectionAction';

type PendingConnectionItemProps = {
  connection: OutgoingConnection;
};

export const OutgoingConnectionItem = ({
  connection,
}: PendingConnectionItemProps) => {
  const connectionDispatch = useConnectionDispatch();
  const cancelRequest = useCancelConnectionRequest(
    connectionDispatch,
    connection,
  );
  const requestConnect = useRequestConnect(connectionDispatch, connection);
  const actionElement = !connection.canceledRequest ? (
    <Button
      onClick={cancelRequest}
      disableElevation
      variant='outlined'
      color='error'
      sx={{ px: 5, py: 1.5, borderRadius: 7.5 }}
    >
      <Typography sx={{ fontWeight: 500 }}>
        <FormattedMessage id='common.cancel' />
      </Typography>
    </Button>
  ) : (
    <Button
      onClick={requestConnect}
      disableElevation
      variant='contained'
      color='primary'
      sx={{ px: 5, py: 1.5, borderRadius: 7.5 }}
    >
      <Typography sx={{ fontWeight: 500 }}>
        <FormattedMessage id='common.connect' />
      </Typography>
    </Button>
  );
  return (
    <ConnectionItem actionElement={actionElement} connection={connection} />
  );
};
